export default __webpack_public_path__ + "static/media/building-right.a9fbe29f.svg";